import { InjectionToken } from '../../injection';
import { SerializableParams } from '../../utils';

import { MobizSession } from '../data/mobiz-session.do';
import { TokenClaims } from '../data/token-claims.do';
import { AuthGrantType } from './auth-token-grant';

export function isAuthGrantType(value: unknown): value is AuthGrantType {
  return typeof value === 'string' && Object.values(AuthGrantType).includes(value as AuthGrantType);
}

export interface IAuthGrantPasswordGrantTypeSecret {
  username: string;
  password: string;
}

export interface IAuthGrantClientCredentialsGrantTypeSecret {
  client_secret: string;
}

export interface IAuthTokenService {
  /**
   * The session.
   *
   * TODO: TP-9490 Make session optional, it's no always available.
   */
  session: MobizSession;
  /**
   * The access token.
   *
   * @deprecated use MobizSession.accessToken from IAuthTokenService.session.
   */
  accessToken: string | null;
  /**
   * The refresh token.
   *
   * @deprecated use MobizSession.refreshToken from IAuthTokenService.session.
   */
  refreshToken: string | null;

  /**
   * The claims retrieved from the access token.
   *
   * @deprecated use MobizSession.getClaimsForAccessToken() from IAuthTokenService.session.
   */
  claims: TokenClaims;

  /** Clears all auth token related data. */
  clearAuthData(): void;

  /**
   * Gets the default header options for the provided grant type.
   */
  getIdentificationHeaders(authGrantType: AuthGrantType): Headers;

  /**
   * Returns the body value for a token refresh API request.
   */
  getTokenRefreshRequestBody(grantType: AuthGrantType): SerializableParams;
}

export const IAuthTokenService: InjectionToken<IAuthTokenService>
    = new InjectionToken<IAuthTokenService>('IAuthTokenService');
